<template>
  <div class="handle-button" style="display: inline">
    <el-button type="default" v-if="userAuth.can_edit_other_info" @click="showContract"
               class="d-flex-row funcbars-button"
               size="mini" style="margin-right: 10px"><i class="el-icon-folder-add"></i>合同归档
    </el-button>
    <!--    合同归档-->
    <AdContractEnter :visible.sync="dialogContract" :order-contract-list="orderContractList"
                     @afterContract="afterContract"/>
  </div>
</template>

<script>
import AdContractEnter from "@/views/adOrder/components/AdContractEnter";

export default {
  name: "AdContractOpt",
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  components: {
    AdContractEnter
  },
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }

    }
  },
  data() {
    return {
      orderContractList: [],
      dialogContract: false,//合同弹窗
    }
  },
  methods: {
    // showContract() {
    //   this.$emit('showContract', this.tableData)
    // },

    showContract() {
      let _selectItems = this.dataList
      if (_selectItems && _selectItems.length > 0) {
        this.dialogContract = true//显示合同弹窗
        this.orderContractList = []
        let contract_nos = []
        let error_msg = false
        _selectItems.forEach((order) => {
          let el = order
          if (el.bool_undo) {
            error_msg = '存在已撤单订单，请去除勾选后再次申请';
            return false;
          }
          // else if (el.is_mark == 1 && el.pid != 0) {
          //   error_msg = '全案营销订单的子订单不能合同归档（跟全案主单即可）';
          //   return false;
          // }
          this.orderContractList.push({
            id: order.id,
            order_no: order.order_no,
            company_name: order.company_name,
            customer_name: order.customer_name,
            sale: order.sale_name,
            payment_account: order.payment_account,
            pay_status: order.pay_status,
            invoice_status: order.invoice_status,
            payment_method: order.payment_method_alias,
            contract_no: order.contract_no,
            created_at: order.created_at,
            contract_filed: order.contract_filed,
            f_remark: order.f_remark,
          })

          if (contract_nos.indexOf(order.contract_no) === -1)
            contract_nos.push(order.contract_no)
        })
        if (error_msg) {
          this.showToast({
            h: this,
            icon: "el-icon-error",
            text: error_msg,
            duration: 2000
          });
          this.dialogContract = false//显示合同弹窗
          return;
        }

        if (contract_nos.length > 1) {
          this.showToast({
            h: this,
            icon: "el-icon-error",
            text: "请注意：存在不同合同编号的订单",
            duration: 2000
          });
        }
      } else {
        this.showToast({
          h: this,
          icon: "el-icon-error",
          text: "请至少勾选一单",
          duration: 2000
        });
      }
    },

    afterContract() {
      this.$emit('afterContract')

    },
  }
}
</script>

<style scoped>

</style>
